import React from 'react';
import { Home, Radio, Clock, GraduationCap, Heart } from 'lucide-react';
import { useAudio } from '../context/AudioContext';

const ITEMS = [
  { id: 'home', label: 'الرئيسية', icon: Home },
  { id: 'radios', label: 'الإذاعات', icon: Radio },
  { id: 'prayer', label: 'المواقيت', icon: Clock },
  { id: 'lessons', label: 'الدروس', icon: GraduationCap },
  { id: 'favorites', label: 'المفضلة', icon: Heart },
];

/**
 * الشريط السفلي.
 *
 * التبويب النشط يُميَّز بامتلاء الأيقونة ووزن النص، لا بشريط متوهّج تحته.
 * التوهّج كان يضيف لوناً ثالثاً لكل شاشة دون أن يقول شيئاً إضافياً.
 */
export const MobileBottomNav = ({ activeMobileTab, setActiveMobileTab }) => {
  const { favorites } = useAudio();

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 safe-bottom-edge bg-paper/95 backdrop-blur-md border-t border-line tv:inset-x-auto tv:right-0 tv:top-0 tv:w-40 tv:border-t-0 tv:border-l"
      aria-label="التنقّل الرئيسي"
    >
      <div className="max-w-md tablet:max-w-3xl mx-auto grid grid-cols-5 h-14 tv:grid-cols-1 tv:h-full tv:content-center tv:gap-2 tv:px-2">
        {ITEMS.map(({ id, label, icon: Icon }) => {
          const active = activeMobileTab === id;
          const badge = id === 'favorites' && favorites.length > 0 ? favorites.length : null;

          return (
            <button
              key={id}
              onClick={() => setActiveMobileTab(id)}
              aria-current={active ? 'page' : undefined}
              className={`relative flex flex-col items-center justify-center gap-1 transition-colors tv:flex-row tv:justify-start tv:gap-3 tv:px-4 tv:py-3 tv:rounded-lg ${
                active ? 'text-primary' : 'text-ink-muted hover:text-ink'
              }`}
            >
              <span className="relative">
                <Icon
                  className="w-[19px] h-[19px]"
                  strokeWidth={active ? 2.2 : 1.7}
                  fill={active && id === 'favorites' ? 'currentColor' : 'none'}
                  aria-hidden="true"
                />
                {badge && (
                  <span className="absolute -top-1 -left-2 min-w-[15px] h-[15px] px-1 rounded-full bg-live text-paper text-[9px] font-semibold flex items-center justify-center">
                    {badge}
                  </span>
                )}
              </span>
              <span className={`text-2xs tv:text-sm leading-none ${active ? 'font-semibold' : ''}`}>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
